import { getAxios, handleErrorMessage, handleResponse } from './apiUtils';

export const get = async query =>
  getAxios()
    .get('/api/news-item/search', { params: { ...query } })
    .catch(handleErrorMessage);

export const getPostById = async ({ siteId, postId }) =>
  getAxios().get(`/api/news-item/site/${siteId}/post/${postId}`).catch(handleErrorMessage).then(handleResponse);

export const getAuthors = async email =>
  getAxios()
    .get('/api/author/search', { params: { email } })
    .catch(handleErrorMessage)
    .then(res => res.data);

export const all = async () =>
  getAxios()
    .get('/api/author')
    .catch(handleErrorMessage)
    .then(res => res.data);

export const getSections = async siteId => {
  try {
    return await getAxios()
      .get('/api/news-item/sections/' + siteId)
      .then(({ data }) => data);
  } catch (error) {
    throw new Error(error.message);
  }
};
export const buildDigestForDate = async (siteId, sendDate) => {
  try {
    return await getAxios()
      .get('/api/daily-digest/build', { params: { siteId, sendDate } })
      .then(({ data }) => data);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getSites = async () => {
  try {
    const { data } = await getAxios().get('/api/property');
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getById = async id => {
  try {
    const { data } = await getAxios().get(`/api/news-item/${id}`);
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const update = async newsItem => {
  try {
    await getAxios().put(`/api/news-item`, newsItem);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const tagPost = async ({ siteId, postId, tags }) => {
  try {
    await getAxios().put(`/api/news-item/site/${siteId}/post/${postId}/tag`, { tags });
  } catch (error) {
    throw new Error(error.message);
  }
};

export const updateEvent = async event => {
  try {
    await getAxios().put(`/api/event`, event);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const add = async newsItem => {
  try {
    const { data } = await getAxios().post(`/api/news-item`, newsItem);
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getPostHistoryById = async ({ id, siteId }) => {
  try {
    const result = await getAxios().get(`/api/rebel-mouse/history?siteId=${siteId}&id=${id}`);
    return result.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const create = async newsItem => {
  try {
    const { data } = await getAxios().post(`/api/news-item/create`, newsItem);
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const deleteArticle = async articleId => {
  try {
    return await getAxios().delete(`/api/news-item/${articleId}`);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const clone = async ({ siteId, sectionId, article }) => {
  try {
    const { data } = await getAxios().post(`/api/news-item/clone?siteId=${siteId}&sectionId=${sectionId}`, article);
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const clone2 = async ({ siteId, sectionId, article }) => {
  try {
    const { data } = await getAxios().post(`/api/news-item/clone3?siteId=${siteId}&sectionId=${sectionId}`, article);
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const publishDraftNewsItem = async newsItem => {
  try {
    await getAxios().post(`/api/news-item/publish-draft`, newsItem);
  } catch (error) {
    throw new Error(error.message);
  }
};
